<template>
    <div>
        <div class="content-header row">
            <div class="content-header-left col-md-7 col-12 mb-2">
                <div class="row breadcrumbs-top">
                    <div class="col-12">
                        <h2 class="content-header-title float-left mb-0">{{trans('general.report')}}
                        </h2>
                        <div class="breadcrumb-wrapper col-12">
                            <ol class="breadcrumb">
                                <li class="breadcrumb-item">
                                    <router-link to="/home">
                                        {{ trans('general.home') }}
                                    </router-link>
                                </li>
                                <li class="breadcrumb-item">
                                    <a href="#">
                                        {{ trans('general.report') }}
                                    </a>
                                </li>
                                <li class="breadcrumb-item active">
                                    Demand Notice
                                </li>
                            </ol>
                        </div>
                    </div>
                </div>
            </div>
            <div class="content-header-right text-md-right col-md-5 col-12 d-md-block d-none">
                <div class="form-group breadcrum-right">
                    <button class="btn btn-primary btn-sm pull-right" v-if="!showFilterPanel" @click="showFilterPanel = !showFilterPanel"><i class="feather icon-filter"></i> {{trans('general.filter')}}</button>

                    <button class="btn btn-primary btn-sm pull-right mr-2" @click="printReport()"><i class="feather icon-printer"></i> Print</button>
                </div>
            </div>

        </div>

    <div class="content-body">
        <section id="basic-datatable">
            <div class="row">
                <div class="col-12">

                    <transition name="fade">
                        <div class="card border-bottom" v-if="showFilterPanel">
                            <div class="card-header">
                                <h4 class="card-title float-left mb-0">{{trans('general.filter')}}</h4>
                                
                            </div>
                            <div class="card-content">
                                <div class="card-body">
                                <div class="row">
                                    <div class="col-4">
                                        <div class="form-group">
                                            <label for="">{{trans('payment.reference_rrr_trx')}}</label>
                                            <input class="form-control" name="keyword" v-model="filterReportForm.keyword">
                                        </div>
                                    </div>
                                    <div class="col-4">
                                        <div class="form-group">
                                            <label for="">Tax Payer</label>
                                            <v-select :options="taxPayers" :reduce="name => name.id" label="name" name="tax_payer_id" v-model="filterReportForm.tax_payer_id"></v-select>
                                        </div>
                                    </div>
                                    <div class="col-2">
                                        <div class="form-group">
                                            <label for="year">Year</label>
                                            <select class="form-control" name="year" v-model="filterReportForm.year">
                                                <option 
                                                v-for="year in yearRange" 
                                                :key="year" 
                                                :value="year"
                                                >
                                                {{ year }}
                                                </option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="col-2">
                                        <div class="form-group">
                                            <label for="">Status</label>
                                            <select class="form-control" name="status" v-model="filterReportForm.status" placeholder="Select Status">
                                                <option value="all">All</option>
                                                <option value="paid">Paid</option>
                                                <option value="unpaid">Unpaid</option>
                                            </select>
                                        </div>
                                    </div>
                                    
                                </div>
                                <button class="btn btn-danger waves-effect waves-light pull-right mr-1 mb-1" v-if="showFilterPanel" @click="showFilterPanel = !showFilterPanel">{{trans('general.cancel')}}</button>
                            </div>
                            </div>
                        </div>
                    </transition>
                    
                    <div class="card">
                        <div class="card-header">
                            <h4 v-if="reports.total" class="card-title">
                                <sort-by :order-by-options="orderByOptions" :sort-by="filterReportForm.sort_by" :order="filterReportForm.order" @updateSortBy="value => {filterReportForm.sort_by = value}"  @updateOrder="value => {filterReportForm.order = value}"></sort-by>
                            </h4>
                        </div>
                        <div class="card-content">
                            <div class="card-body">
                                <h3 class="mb-4">Demand Notice Summary ({{ filterReportForm.year }})</h3>
                                <table class="table table-bordered table-striped text-left">
                                    <thead class="table-dark">
                                        <tr>
                                        <th>Metric</th>
                                        <th>Total ({{ filterReportForm.year }})</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                        <td>Total Demand Notice Generated</td>
                                        <td>{{ totals.total_generated | formatMoney }}</td>
                                        </tr>
                                        <tr>
                                        <td>Total Paid</td>
                                        <td>{{ totals.total_paid | formatMoney }}</td>
                                        </tr>
                                        <tr>
                                        <td>Total Pending</td>
                                        <td>{{ totals.total_pending | formatMoney }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                                
                                <div class="table-responsive" v-if="reports.total">
                                    <table class="table">
                                    <thead>
                                        <tr>
                                            <th>{{trans('general.serial_number')}}</th>
                                            <th>{{trans('general.date')}}</th>
                                            <th>{{trans('payment.tax_id')}}</th>
                                            <th>{{trans('payment.payer')}}</th>
                                            <th>{{trans('payment.amount')}}</th>
                                            <th>{{trans('payment.reference')}}</th>
                                            <th>{{trans('general.status')}}</th>
                                            <th class="table-option">{{trans('general.action')}}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(report, index) in reports.data">
                                            <td v-text="index+1"></td>
                                            <td>{{report.created_at | momentDateTime}}</td>
                                            <td v-text="report.tax_id"></td>
                                            <td v-text="report.tax_payer_name"></td>
                                            <td>{{ report.amount | formatMoney }}</td>
                                            <td v-text="report.transaction_reference"></td>
                                            <td v-html="getStatus(report)"></td>
                                            <td class="table-option">
                                                <div class="btn-group">
                                                    <a :href="`/demand-notice/${report.transaction_reference}/print`" target="_blank" class="btn btn-primary btn-sm" v-tooltip="trans('general.view')"><i class="feather icon-eye" ></i></a>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                    
                                </table>
                            </div>
                            <module-info v-if="!reports.total" module="report" title="module_info_title" description="module_info_description" icon="check-circle">
                                <div slot="btn">
                                    <button class="btn btn-primary btn-md" @click="$router.push('/report/create')"><i class="feather icon-plus"></i> {{trans('general.add_new')}}</button>
                                </div>
                            </module-info>
                            <pagination-record :page-length.sync="filterReportForm.page_length" :records="reports" @updateRecords="getReports"></pagination-record>
                             
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
   
   </div>
    </div>
</template>

<script>
    import sortBy from '../../components/sort-by'
    import dateRangePicker from '../../components/date-range-picker'

    export default {
        components : { sortBy,dateRangePicker },
        data() {
            return {
                userRole: '',
                reports: {
                    total: 0,
                    data: [],
                    totals: []
                },
                filterReportForm: {
                    keyword: '',
                    tax_payer_id: '',
                    status: 'all',
                    year: new Date().getFullYear(),
                    sort_by : 'created_at',
                    order: 'desc',
                    page_length: 50
                },
                taxPayers: [],
                gateways: [],
                orderByOptions: [
                    {
                        value: 'tax_id',
                        translation: i18n.payment.tax_id
                    },
                    {
                        value: 'payer',
                        translation: i18n.payment.payer
                    },
                    {
                        value: 'reference',
                        translation: i18n.payment.reference
                    }
                ],
                showFilterPanel: true,
                yearRange: []
            };
        },
        created() {
            this.generateYearRange();
        },
        mounted(){
            if(!helper.hasPermission('list-report')){
                helper.notAccessibleMsg();
                this.$router.push('/home');
            }

            if(!helper.featureAvailable('report')){
                helper.featureNotAvailableMsg();
                this.$router.push('/home');
            }

            this.getReports();
            this.userRole = this.getRole()[0];
            this.fetchPreRequisites();
        },
        methods: {
            printReport() {
                let url = window.appUrl;
                window.open(url + '?type=demand_notice&tax_payer_id=' + this.filterReportForm.tax_payer_id + '&year=' + this.filterReportForm.year + '&status=' + this.filterReportForm.status + '&user_id=' + this.filterReportForm.tax_payer_id, "_blank");
            },
            getGatewayName(report) {
                return report.gateway?.name ?? "--";
            },
            fetchPreRequisites(){
                axios.get('/api/user/pre-requisite')
                    .then(response => response.data)
                    .then(response => {
                        this.taxPayers = response.businessTaxPayers;
                        this.gateways = response.gateways;
                    })
                    .catch(error => {
                        helper.showDataErrorMsg(error)
                    });
            },
            getRole(role){
              return helper.getRole(role);
            },
            hasPermission(permission){
                return helper.hasPermission(permission);
            },
            hasRole(role){
                return helper.hasRole(role);
            },
            getReports(page){
                if (typeof page !== 'number') {
                    page = 1;
                }
                let url = helper.getFilterURL(this.filterReportForm);
                axios.get('/api/report/demand-notice?page=' + page + url)
                .then(response => response.data)
                .then(response => {
                    this.reports = response.data;
                    this.totals = response.totals;
                })
                .catch(error => {
                    helper.showDataErrorMsg(error);
                });
            },
            getStatus(payment){
                return payment.remark == 'success' ? ('<span class="badge badge-success">'+i18n.payment.paid+'</span>') : ('<span class="badge badge-danger">'+i18n.payment.not_paid+'</span>') ;
            },
            generateYearRange() {
                const currentYear = new Date().getFullYear();
                const startYear = 2020; // Adjust this as needed
                
                // Create array from current year back to startYear
                for (let year = currentYear; year >= startYear; year--) {
                    this.yearRange.push(year);
                }
            }
        },
        filters: {
          momentDateTime(date) {
            return helper.formatDateTime(date);
          },
          formatMoney(value){
            return helper.formatMoney(value);
          }
        },
        watch: {
            filterReportForm: {
                handler(val){
                    setTimeout(() => {
                        this.getReports();
                    }, 500)
                },
                deep: true
            }
        }
    }
</script>
